export default __webpack_public_path__ + "static/media/heart-in-hand.87668c0a.svg";